import { get } from './api';
import { TicketPriorityI } from 'declarations/interfaces/ticketPriorities';

export const getPrioritiesApi = async () => {
  const response = await get<TicketPriorityI[]>(`/tickets/priorities`);

  return response.data;
};
